<template>
    <div class="dashboard">
        <navbar></navbar>
        <section class="is-medium">
            <div class="columns is-mobile is-centered">
                <div class="column is-half">
                    <div class="tile is-ancestor user-tile">
                        <div class="tile is-parent">
                            <div class="tile is-child box">
                                <p class="title">Full Report</p>
                                <div class="control">
                                    <a class="button is-rounded is-info is-medium" @click="downloadFull">
                                        Download
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Navbar from "../components/Navbar.vue";
    export default {
        name: "Profile",
        components: {Navbar},
        computed: {
            name () {
                return this.$store.state.user.name
            },
            email () {
                return this.$store.state.user.email
            }

        },

        methods: {
            downloadFull() {
                let url = process.env.VUE_APP_API
                this.$http({
                    url: url + "/locations/" + this.$store.getters.default_location_id + "/reports?type=complete_pdf",
                    method: 'GET',
                    responseType: 'blob',
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'file.pdf');
                    document.body.appendChild(link);
                    link.click();
                });
            }
        }
    }
</script>

<style scoped>
    .user-tile {
        max-width: 600px;
    }

    table, th {
        padding-right: 15px;
        padding-left: 15px;
    }

    .card {
        border-radius: 10px;
    }

    .login-title {
        color: #0f81cc;
        font-size: 1.5rem;
    }

    .card-content p {
        margin: 10px;
    }
    .card-content img {
        max-height: 1.75rem;
    }
</style>